export var HttpMethod;
(function (HttpMethod) {
    HttpMethod["Get"] = "get";
    HttpMethod["Post"] = "post";
    HttpMethod["Put"] = "put";
    HttpMethod["Patch"] = "patch";
    HttpMethod["Delete"] = "delete";
})(HttpMethod || (HttpMethod = {}));
